export enum AppRoute {
    ACTION_REQUIRED = '/action-required',
    DOWNLOADER = '/downloader',
    EXPLORE = '/explore',
    FAKE_LIBRARY_ALBUM_DETAILS = '/library/albums/dummy/:albumId',
    FAVORITES = '/favorites',
    HOME = '/',
    LIBRARY_ALBUM_ARTISTS = '/library/album-artists',
    LIBRARY_ALBUM_ARTISTS_DETAIL = '/library/album-artists/:albumArtistId',
    LIBRARY_ALBUM_ARTISTS_DETAIL_DISCOGRAPHY = '/library/album-artists/:albumArtistId/discography',
    LIBRARY_ALBUM_ARTISTS_DETAIL_FAVORITE_SONGS = '/library/album-artists/:albumArtistId/favorite-songs',
    LIBRARY_ALBUM_ARTISTS_DETAIL_SONGS = '/library/album-artists/:albumArtistId/songs',
    LIBRARY_ALBUM_ARTISTS_DETAIL_TOP_SONGS = '/library/album-artists/:albumArtistId/top-songs',
    LIBRARY_ALBUMS = '/library/albums',
    LIBRARY_ALBUMS_DETAIL = '/library/albums/:albumId',
    LIBRARY_ARTISTS = '/library/artists',
    LIBRARY_ARTISTS_DETAIL = '/library/artists/:artistId',
    LIBRARY_ARTISTS_DETAIL_DISCOGRAPHY = '/library/artists/:artistId/discography',
    LIBRARY_ARTISTS_DETAIL_FAVORITE_SONGS = '/library/artists/:artistId/favorite-songs',
    LIBRARY_ARTISTS_DETAIL_SONGS = '/library/artists/:artistId/songs',
    LIBRARY_ARTISTS_DETAIL_TOP_SONGS = '/library/artists/:artistId/top-songs',
    LIBRARY_FOLDERS = '/library/folders',
    LIBRARY_GENRES = '/library/genres',
    LIBRARY_GENRES_DETAIL = '/library/genres/:genreId',
    LIBRARY_SONGS = '/library/songs',
    LOGIN = '/login',
    NO_NETWORK = '/no-network',
    NOW_PLAYING = '/now-playing',
    PLAYING = '/playing',
    PLAYLISTS = '/playlists',
    PLAYLISTS_DETAIL_SONGS = '/playlists/:playlistId/songs',
    RADIO = '/radio',
    SEARCH = '/search/:itemType',
    SERVERS = '/servers',
    SETTINGS = '/settings',
}
